(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yarny-announcement"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('.yarny-announcement');

    sections.forEach(initAnnouncement);

        // ── Scroll la formularul de newsletter din footer (linkuri #newsletter) ──
    function ycScrollToNewsletter() {
      var target = document.querySelector('.yarny-footer__column--newsletter')
                || document.querySelector('.yarny-footer__form');
      if (!target) return false;
      var header = document.querySelector('.yarny-header__pill, header, .header');
      var offset = (header ? header.getBoundingClientRect().height : 0) + 20;
      var y = target.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: y, behavior: 'smooth' });
      var input = target.querySelector('input[type="email"]');
      if (input) setTimeout(function () { input.focus({ preventScroll: true }); }, 700);
      return true;
    }
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href*="#newsletter"]');
      if (!link) return;
      if (ycScrollToNewsletter()) e.preventDefault();
    });
    if (location.hash === '#newsletter') {
      window.addEventListener('load', function () { setTimeout(ycScrollToNewsletter, 100); });
    }

    function initAnnouncement(root) {
      // ===== MESSAGE SLIDER =====
      const messages = root.querySelectorAll('.yarny-announcement__message');
      const prevBtn = root.querySelector('.yarny-announcement__arrow--prev');
      const nextBtn = root.querySelector('.yarny-announcement__arrow--next');
      const autoplay = root.dataset.autoplay === 'true';
      const autoplaySpeed = parseInt(root.dataset.autoplaySpeed, 10) || 5000;

      let currentIndex = 0;
      let autoplayTimer = null;

      function showMessage(index) {
        messages.forEach((msg, i) => {
          msg.classList.toggle('is-active', i === index);
        });
        currentIndex = index;
      }

      function next() {
        const newIndex = (currentIndex + 1) % messages.length;
        showMessage(newIndex);
      }

      function prev() {
        const newIndex = (currentIndex - 1 + messages.length) % messages.length;
        showMessage(newIndex);
      }

      function startAutoplay() {
        if (!autoplay || messages.length <= 1) return;
        stopAutoplay();
        autoplayTimer = setInterval(next, autoplaySpeed);
      }

      function stopAutoplay() {
        if (autoplayTimer) {
          clearInterval(autoplayTimer);
          autoplayTimer = null;
        }
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          prev();
          stopAutoplay();
          startAutoplay();
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          next();
          stopAutoplay();
          startAutoplay();
        });
      }

      // Pause on hover
      root.addEventListener('mouseenter', stopAutoplay);
      root.addEventListener('mouseleave', startAutoplay);

      // Pause when tab is hidden
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          stopAutoplay();
        } else {
          startAutoplay();
        }
      });

      // Respect reduced motion
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        startAutoplay();
      }

      // ===== LOCALE SELECTOR =====
      const localeButton = root.querySelector('.yarny-announcement__locale-button');
      const localeList = root.querySelector('.yarny-announcement__locale-list');

      if (localeButton && localeList) {
        localeButton.addEventListener('click', (e) => {
          e.stopPropagation();
          const isOpen = localeButton.getAttribute('aria-expanded') === 'true';
          localeButton.setAttribute('aria-expanded', String(!isOpen));
          localeList.hidden = isOpen;
        });

        // Close on outside click
        document.addEventListener('click', (e) => {
          if (!root.contains(e.target)) {
            localeButton.setAttribute('aria-expanded', 'false');
            localeList.hidden = true;
          }
        });

        // Close on Escape
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') {
            localeButton.setAttribute('aria-expanded', 'false');
            localeList.hidden = true;
            localeButton.focus();
          }
        });

        // Keyboard navigation inside list
        const options = localeList.querySelectorAll('.yarny-announcement__locale-option');
        options.forEach((opt, i) => {
          opt.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowDown') {
              e.preventDefault();
              const next = options[i + 1] || options[0];
              next.focus();
            } else if (e.key === 'ArrowUp') {
              e.preventDefault();
              const prev = options[i - 1] || options[options.length - 1];
              prev.focus();
            }
          });
        });
      }
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
